<template>
	<f7-page ref="self" :page-content="false" class="releazio-api-page">
		<f7-navbar>
			<f7-nav-left>
				<a href="#" class="link icon-only" @click="back">
					<i class="icon-back icon"></i>
				</a>
			</f7-nav-left>
			<f7-nav-title>
				{{ $t("g.settings.releazioApi.title") }}
			</f7-nav-title>
			<f7-nav-right></f7-nav-right>
		</f7-navbar>
		<f7-page-content>
			<p class="list-title">{{ $t('g.settings.releazioApi.listUrl.title') }}</p>
			<f7-list class="list-dividers list-strong list-outline">
				<f7-list-item
					v-for="(domain, key) in domainSettings"
					:key="key"
					@change="updateUrlHandler(key)"
					radio
					radio-icon="end"
					:title="domain.title"
					:value="domain.url"
					:checked="selectedDomainSettingProp === key"
					name="api"
				/>
			</f7-list>
			<list-input-with-title
				:title="$t('g.settings.releazioApi.inputKey.title')"
				v-model:text="apiKey"
				:placeholder="$t('g.settings.releazioApi.inputKey.placeholder')"
				:disabled="isDefaultApiKey"
				@on-clear="clearInputApiKeyHandler"
				:show-clear-button="isCanClearApiKey"
				@on-blur="blurInputApiKeyHandler"
			>
				<template v-if="isCanResetApiKey || isCanSaveApiKey" #content-end>
					<div class="releazio-api-page-input-buttons">
						<f7-button
							v-if="isCanResetApiKey"
							class="theme-type mini"
							@click="resetInputApiKeyHandler"
						>
							{{ $t("g.settings.releazioApi.inputKey.reset") }}
						</f7-button>
						<f7-button
							v-if="isCanSaveApiKey"
							class="theme-type mini"
							@click="saveInputApiKeyHandler"
						>
							{{ $t("g.settings.releazioApi.inputKey.save") }}
						</f7-button>
					</div>
				</template>
			</list-input-with-title>
		</f7-page-content>
	</f7-page>
</template>

<script setup lang="ts">
import {f7} from "framework7-vue";
import {computed} from "vue";
import ListInputWithTitle from "@components/atomic/list-item/ListInputWithTitle.vue";
import {
	ReleazioDomainSettingTypes,
	ServiceReleazioApiSettings
} from "@/services/v2/service-releazio-api-settings/ServiceReleazioApiSettings";


const serviceReleazioApi = ServiceReleazioApiSettings.of();
const {
	apiKey,
	customApiKey,
	domainSettings,
	selectedDomainSettingProp,
	selectedDomainSetting
} = serviceReleazioApi;

const isDefaultApiKey = computed(() => selectedDomainSettingProp.value === ReleazioDomainSettingTypes.DEFAULT);
const isCanResetApiKey = computed(() => !isDefaultApiKey.value && apiKey.value.length > 0 && apiKey.value !== selectedDomainSetting.value.apiKey && customApiKey.value !== null && customApiKey.value!.length > 0);
const isCanClearApiKey = computed(() => !isDefaultApiKey.value && apiKey.value.length > 0 && apiKey.value === selectedDomainSetting.value.apiKey);
const isCanSaveApiKey = computed(() => !isDefaultApiKey.value && apiKey.value.length > 0 && apiKey.value !== selectedDomainSetting.value.apiKey && customApiKey.value === null);

const back = () => {
	f7.view.current.router.back();
}

const updateUrlHandler = (value: ReleazioDomainSettingTypes) => {
	serviceReleazioApi.updateReleazioSettings(value);
}

const clearInputApiKeyHandler = () => {
	apiKey.value = '';
}

const resetInputApiKeyHandler = () => {
	serviceReleazioApi.resetReleazioCustomSettings();
}

const saveInputApiKeyHandler = () => {
	serviceReleazioApi.saveReleazioCustomSettings();
}

const blurInputApiKeyHandler = () => {
	if (!apiKey.value.trim().length) {
		apiKey.value = selectedDomainSetting.value.apiKey;
	}
}
</script>

<style lang="scss">
	@import "@/scss/views/settings-view";

	.releazio-api-page-input-buttons {
		padding-right: 12px;
	}
</style>
